module.exports = __webpack_public_path__ + "fontello.76cc19487d6e94105333.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/font/fontello.woff?3640046
// module id = ../../../../../src/assets/font/fontello.woff?3640046
// module chunks = styles